/**
 * MaxLength validator
 * Validates that a string value does not exceed the maximum length
 *
 * Usage: validators: { MaxLength: { max: 255 } }
 *
 * @param {object} errors - The errors object to populate
 * @param {any} value - The field value to validate
 * @param {object} item - The full item being edited
 * @param {object} params - { max: number }
 * @param {object} field - The field definition
 */
export default async function maxLengthValidator(errors, value, item, params, field) {
  if (!value) return // Skip validation if no value

  const max = params?.max || 255
  const stringValue = String(value)

  if (stringValue.length > max) {
    errors[field.id] = `${field.label || 'Value'} must not exceed ${max} characters (currently ${stringValue.length})`
  }
}
